module.exports = __webpack_public_path__ + "static/media/cyclic_quad1.08079a9f.jpg";